import { DropDownList, TextBox } from "@repo/ui";

import type { SettingEnumOption } from "../../../models";

import { ApplicationSettingType } from "../../../models";

interface Props {
	type?: ApplicationSettingType | null;
	/** The definition's options for an Enum */
	enumOptions?: SettingEnumOption[] | null;
	value: string;
	onChange: (value: string) => void;
}

const booleanOptions = [
	{ value: "true", label: "true" },
	{ value: "false", label: "false" },
];

/** A value input that fits the setting's type: a true/false or enum dropdown, a number box, or a text box */
export function ValueInput({ type, enumOptions, value, onChange }: Props) {
	const options = type === ApplicationSettingType.Boolean ? booleanOptions : (enumOptions ?? []);

	if (type === ApplicationSettingType.Boolean || (type === ApplicationSettingType.Enum && options.length))
		return (
			<DropDownList
				label="Value"
				values={options}
				value={value || null}
				fullLength
				changeHandler={(selected: string) => onChange(selected ?? "")}
			/>
		);

	if (type === ApplicationSettingType.Int)
		return (
			<TextBox
				label="Value"
				type="number"
				inputMode="numeric"
				step="1"
				value={value}
				changeHandler={(entered) => onChange(entered ?? "")}
			/>
		);

	return (
		<TextBox
			label="Value"
			placeholder={type === ApplicationSettingType.StringList ? "Comma-separated values" : undefined}
			value={value}
			changeHandler={(entered) => onChange(entered ?? "")}
		/>
	);
}
